module.exports = __webpack_public_path__ + "static/img/OC_bg01.27a73a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/form/runtime/components/assets/OC_bg01.png
// module id = Gq0j
// module chunks = 7